import {
  Component, EventEmitter, Input, OnInit,
  Output,
} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {faUser} from '@fortawesome/free-regular-svg-icons';
import {faLock} from '@fortawesome/free-solid-svg-icons';
import {FormHandler} from "@iw-shared/form/models/form-handler";

@Component({
  selector: 'iw-shared-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Output() onValidationSuccess: EventEmitter<{ username: string, password: string }> = new EventEmitter<{
    username: string,
    password: string
  }>();
  @Input() formHandler!: FormHandler;


  private ngUnsubscribe: Subject<void> = new Subject<void>();

  faUser = faUser;
  faLock = faLock;

  form: FormGroup = this.fb.group({
    username: ['', [Validators.required]],
    password: ['', [Validators.required]]
  });


  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.formHandler.setFormStatus({formStatus: null});
  }

  isFormKeyInvalid(key: string, displayIfSubmitForm: boolean = true): boolean {
    let form = this.form?.get(key);
    return !!(form?.invalid &&
      (
        this.formHandler.getFormStatus() == 'submitForm' &&
        displayIfSubmitForm
      )
    );
  }

  submit() {
    if (this.form.invalid) {
      this.formHandler.setFormStatus({formStatus: 'submitForm'});
      return;
    }
    if (this.formHandler.getFormStatus() == 'loading') {
      return;
    }
    this.formHandler.setFormStatus({formStatus: 'loading'});
    this.onValidationSuccess.emit({username:  this.form.get('username')?.value ?? '', password: this.form.get('password')?.value ?? ''})
  }




}

